const namespace = 'recurringAvailability';

export const FETCH_RECURRING_AVAILABILITY = `${namespace}/FETCH_RECURRING_AVAILABILITY`;
export const UPDATE_RECURRING_AVAILABILITY = `${namespace}/UPDATE_RECURRING_AVAILABILITY`;
export const SET_RECURRING_AVAILABILITY = `${namespace}/SET_RECURRING_AVAILABILITY`;
export const RESET_RECURRING_AVAILABILITY = `${namespace}/RESET_RECURRING_AVAILABILITY`;
